import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import HomeTopSlider from '../home/home-top-slider';
import HomeCollectionCards from '../home/home-collection-cards';
import HomeTopCTA from '../home/home-top-cta';
import HomeBoxSlider from './home-boxed-slider';
import HomeSplitSection from './home-split-section';
import HomeInstagram from './home-instagram';
import HomeNewsletter from './home-newsletter';
import HomeCTABottomBanner from './home-cta-bottom-banner';

import { media } from '../../helpers';

const HomePageContainer = styled.div`
    .split-section-outer-container {
        position: relative;
        ${media.medium`bottom: -50vh;margin-top: -50vh;`}
    }
`;

const HomePage = () => {
    const data = useStaticQuery(graphql`
        query {
            home: allWpPage(filter: { title: { eq: "Home" } }) {
                edges {
                    node {
                        id
                        home_acf {
                            splitSection1 {
                                splitSectionCaption
                                splitSectionTitle
                                splitSectionImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1000, quality: 90) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                splitSectionButton {
                                    title
                                    url
                                }
                                splitSectionIcons {
                                    iconBlurb
                                    iconTitle
                                    iconImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(
                                                    maxWidth: 300
                                                    quality: 90
                                                ) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            splitSection2 {
                                splitSectionCaption
                                splitSectionTitle
                                splitSectionImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1000, quality: 90) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                splitSectionButton {
                                    title
                                    url
                                }
                                splitSectionIcons {
                                    iconBlurb
                                    iconTitle
                                    iconImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(
                                                    maxWidth: 300
                                                    quality: 90
                                                ) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { splitSection1, splitSection2 } =
        (data && data.home.edges[0].node.home_acf) || {};
    return (
        <HomePageContainer>
            <HomeTopSlider />
            <HomeCollectionCards />
            <HomeTopCTA />
            {/* 1 */}
            <HomeBoxSlider />
            <div className="split-section-outer-container">
                <HomeSplitSection content={splitSection1} />
            </div>
            <HomeInstagram />
            <HomeNewsletter />
            {/* 2 */}
            <div className="split-section-outer-container">
                <HomeSplitSection content={splitSection2} flipped={true} />
            </div>
            <HomeCTABottomBanner />
        </HomePageContainer>
    );
};

export default HomePage;
